
import { FormState, FormAction } from './types';

export const initialState: FormState = {
  currentPage: 1,
  formData: {},
  errors: {},
  isSubmitting: false,
  isSubmitted: false,
};

export function formReducer(state: FormState, action: FormAction): FormState {
  switch (action.type) {
    case 'SET_PAGE':
      return { ...state, currentPage: action.payload };
    case 'SET_FIELD':
      return { 
        ...state, 
        formData: { 
          ...state.formData, 
          [action.payload.name]: action.payload.value 
        } 
      };
    case 'SET_ERROR':
      return { 
        ...state, 
        errors: { 
          ...state.errors, 
          [action.payload.name]: action.payload.error 
        } 
      };
    case 'CLEAR_ERROR':
      const newErrors = { ...state.errors };
      delete newErrors[action.payload];
      return { ...state, errors: newErrors };
    case 'LOAD_SAVED_DATA':
      return {
        ...state,
        ...action.payload,
      };
    case 'SUBMIT_START':
      return { ...state, isSubmitting: true };
    case 'SUBMIT_SUCCESS':
      return { ...state, isSubmitting: false, isSubmitted: true };
    case 'SUBMIT_ERROR':
      return { ...state, isSubmitting: false };
    default:
      return state;
  }
}
